define(function (require) {
    "use strict";

    var LE = require("app");
    var Logger = require('logger');
    var template = require("manager-templates/manageDomainsBoxView.tmpl");
    var ManageDomainsBoxListView = require("manager-views/ManageDomainsBoxListView");
    var ManageDomainsBoxCollection = require("manager-collections/ManageDomainsBoxCollection");
    var InputField = require("ui/input-field/InputField");
    var Button = require("ui/button/Button");

    var TYPE = {
        WHITE:      "whiteList",
        BLACK:      "blackList"
    };

    var ManageDomainsBoxView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        ManageDomainsBoxView = Marionette.ItemView.extend({
            template : template,
            ui : {
                cbContainer : ".cb-container",
                manageDomainsBoxContainer : ".cb-content",
                addLink : ".cb-add-more"
            },
            uiComponents: {
                addDomainLink: {
                    type: Button,
                    options: {
                        el: "view.ui.addLink",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addItem"
                    }
                },
                manageDomainsBoxListView: {
                    type: ManageDomainsBoxListView,
                    options: {
                        el: "view.ui.manageDomainsBoxContainer",
                        collection: "view._getCollection"
                    }
                }
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            onClose: function() {
                LEManager.logger.debug("Manage domains items is closed. re-init it.", "ManageDomainsBoxView:onClose");
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/

            _initialize : function (options) {
                this.logger = Logger.getLogger("LEManager");
                this.logger.info("Manage Domains " + options.type + " Box initializing", "ManageDomainsBoxView:initialize. options = " + options);
                this.channel = LEManager.media.channel("manageDomains");
                this.model = new Backbone.Model();
                this.model.set("type", options.type);
                this.model.set("titleBox", LE.translator.translate("LEManager.manage.domains." + options.type));
                this.model.set("descriptionBox", LE.translator.translate("LEManager.manage.domains." + options.type + ".description"));
            },

            _onRender : function () {
                this.logger.info("Manage Domains Box rendering", "ManageDomainsBoxView:_onRender");
                this._bindEvents();
                this.renderIncludeHeader();
            },

            _bindEvents : function () {
                this.logger.debug("Manage Domains Box rendering", "ManageDomainsBoxView:_onRender");
                this.listenTo(this.collection, "add", this.renderIncludeHeader);
                this.listenTo(this.collection, "remove", this.renderIncludeHeader);
                this.listenTo(this.uiComponents.manageDomainsBoxListView, "itemview:close:clicked", function (childView, model) {
                    this.logger.debug("Url item removed from external referral condition box", "ManageDomainsBoxView:bindEvents");
                    this.collection.remove(model);
                    if (this.collection.size() === 0) {
                        this._addItem();
                    }
                });
            },

            //show the title of the the cb only if we have at least one include
            renderIncludeHeader : function () {
                this._renderCSSClasses(this.collection, this.ui.cbContainer);
            },

            //the order in which the classes need to be evaluated
            _renderCSSClasses : function(collection, container) {
                this._managePopulationState(collection, container);
                this._manageSingleItemState(collection, container);
            },

            //manages the "single-item" class, that hides the closing "x" when there is only one item
            _manageSingleItemState : function(collection, container) {
                //decide if there should be an 'x' (for closing) next to the textbox
                var toToggleX = collection.size() === 1 && _.isEmpty(collection.first().get("url"));
                container.toggleClass("single-item", toToggleX);
            },

            //sets the classes "populated", "cb-add-more" and "single-item" to be in charge of the display of
            //the title, the "more" link and the closing "x"
            _managePopulationState : function(collection, container) {

                //in charge of showing the title before the start of the collection items
                var showPopulatedCSS = collection.length > 0;
                container.toggleClass("populated",showPopulatedCSS);
            },

            _addItem : function () {
                this.logger.debug("New url item added to external referral condition box", "ManageDomainsBoxView:_addItem");
                this.collection.addItem();
            },

            _getCollection: function() {
                return this.collection;
            }
        });
    });

    ManageDomainsBoxView.TYPE = TYPE;
    return ManageDomainsBoxView;
});